<div class="twofa-container" fxLayout="column" fxLayoutAlign="start stretch">
  <!-- header image / title -->
  <div class="twofa-header" fxLayout="column" fxLayoutAlign="start stretch">
    <h2 class="twofa-title">Enter 2FA code</h2>
    <p class="twofa-subtitle">
      We’ve sent a 6-digit code to your device via SMS or to your email — depending on the method you initially selected. Enter it to continue.
    </p>
  </div>

  <!-- form -->
  <form
    class="twofa-form"
    [formGroup]="form"
    (ngSubmit)="submit()"
    fxLayout="column"
    fxLayoutGap="14px"
  >
    <mat-form-field appearance="fill" class="code-field">
      <mat-label>6-digit code</mat-label>
      <input
        matInput
        formControlName="code"
        inputmode="numeric"
        maxlength="6"
        autocomplete="one-time-code"
        class="code-input"
        cdkFocusInitial
      />
      <mat-hint align="end">{{ form.value.code?.length || 0 }}/6</mat-hint>
      <mat-error *ngIf="form.get('code')?.hasError('required')">
        Code is required
      </mat-error>
      <mat-error *ngIf="form.get('code')?.hasError('pattern')">
        Enter exactly 6 digits
      </mat-error>
      <mat-error *ngIf="form.get('code')?.hasError('invalid')">
        Invalid code, try again
      </mat-error>
    </mat-form-field>

    <button
      mat-raised-button
      color="primary"
      class="aum-button verify-btn"
      [disabled]="form.invalid || isLoading"
      type="submit"
    >
      VERIFY
    </button>

    <button type="button" mat-button class="cancel-btn" (click)="close()">
      Cancel
    </button>
  </form>

  <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
</div>
